import Text from "@components/atoms/Text";
import { CalculatorFormProps } from "./CalculatorForm.types";
import { SliderInput } from "../SliderInput";
import { TenureOption } from "../TenureOption";
import styles from "./CalculatorForm.module.scss";

export const CalculatorForm = ({
  activeTab,
  formData,
  tenureOptions,
  onEmiChange,
  onLoanChange,
  onDownPaymentChange,
  onInterestChange,
  onTenureChange,
}: CalculatorFormProps) => (
  <div className={styles.wrapper}>
    {activeTab === "emi" ? (
      <SliderInput
        prefix="₹"
        label="EMI amount"
        value={formData.emi!.value}
        min={formData.emi!.min}
        max={formData.emi!.max}
        step={formData.emi!.step}
        onChange={onEmiChange!}
      />
    ) : (
      <SliderInput
        prefix="₹"
        label="Loan amount"
        value={formData.loan!.value}
        min={formData.loan!.min}
        max={formData.loan!.max}
        step={formData.loan!.step}
        onChange={onLoanChange!}
      />
    )}

    <SliderInput
      prefix="₹"
      label="Down payment amount"
      value={formData.downPayment.value}
      min={formData.downPayment.min}
      max={formData.downPayment.max}
      step={formData.downPayment.step}
      onChange={onDownPaymentChange}
    />

    <SliderInput
      label="Interest rate"
      value={formData.interest.value}
      min={formData.interest.min}
      max={formData.interest.max}
      step={formData.interest.step}
      suffix="%"
      onChange={onInterestChange}
    />

    <div>
      <Text className={styles.tenureHeading}>Loan tenure (in months)</Text>
      <div className={styles.tenureOptions}>
        {tenureOptions.map((t) => (
          <TenureOption
            key={t}
            value={t}
            isSelected={formData.tenure === t}
            onClick={onTenureChange}
          />
        ))}
      </div>
    </div>
  </div>
);
